var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.$t("message.companyProfile.listings.subtitle.mainSection"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }